import {InterestedPartyType} from '../components/InterestedParty';

export default {
  promotionPage: {
    actionButton: {
      event: 'Share This Event',
      offer: 'Sign Up',
      giveaway: 'Enter Now',
    },
    // These strings are built for sharing the promotion. As such, HTML entities don't need to be escaped (I think ¯\_(ツ)_/¯)
    shareSubject: {
      event: 'You are invited to {{{ title }}} by {{{ practiceName }}}',
      offer: 'Here are the details for {{{ title }}} at {{{ practiceName }}}',
      giveaway:
        'Here are the details for {{{ title }}} at {{{ practiceName }}}',
    },
    shareMessage: {
      event: 'You are invited to {{{ title }}} by {{{ practiceName }}}',
      offer: 'Here are the details for {{{ title }}} at {{{ practiceName }}}',
      giveaway:
        'Here are the details for {{{ title }}} at {{{ practiceName }}}',
    },
    timeTitle: {
      event: 'Date and Time',
      offer: 'Offer Valid Through',
      giveaway: 'Giveaway Entry Period',
    },
    locationTitle: 'Location',
    onlineEventTitle: 'Online Event',
    multipleLocationsLink: 'Multiple Locations',
    addToCalendar: {
      link: 'Add To Calendar',
      google: 'Google',
      iCal: 'iCal',
      outlook: 'Outlook',
    },
    viewMapLink: 'View Map',
    locationMap: {
      officeLocationList: {
        title: 'Locations',
      },
      error: {
        headline: 'Something went wrong!',
        message: `We're sorry, but we're having trouble loading the map. Please try again later.`,
      },
    },
    aboutUs: {
      contact: 'Contact Us',
      about: 'About Us',
    },
    image: {
      main: {
        alt: 'Promotion Image',
      },
      backdrop: {
        alt: 'Promotion Backdrop Image',
      },
    },
    giveaways: {
      enterGiveaway: {
        confirmEnter: 'Ok',
        title: "You're entered! 🎉",
        body: "You're entered in the giveaway!",
      },
      banner: {
        left: 'left',
        start: 'until start',
        totalEntries: 'total entries',
        userEntries: 'your entries',
      },
      bonusEntries: {
        title: 'Bonus ways to win!',
        subtitle: 'Total bonus entries',
        redeem: {
          current:
            'You currently have {{ #strong }}{{{ points}}} points{{ /strong }} total.',
          confirm:
            'Confirm that you want to redeem your points for bonus entries.',
          adornment: 'Entries',
          notEnough: "You don't have enough points for this amount of entries.",
          minError: 'The number of entries must be at least 1.',
          redeemButton: 'Redeem',
        },
      },
      workflow: {
        earnButton: 'Other ways to earn',
        revealButton: 'Reveal Winner',
        winnerMessage: 'Contact the office within 7 days to claim your prize',
      },
      error: 'Something went wrong. Please try again.',
      terms: {
        title: `NO PURCHASE NECESSARY TO ENTER OR WIN. A PURCHASE WILL NOT IMPROVE YOUR CHANCES OF WINNING. VOID WHERE PROHIBITED BY LAW.`,
        eligibility: `ELIGIBILITY: The {{practiceName}} Giveaway (the “Giveaway”) is open to all individuals who are at least 13 years old at the time of entry, and who have the consent of their parent or legal guardian to enter, except where prohibited or restricted by law. Individuals who are under 18 years old at the time of entry must have the consent of their parent or legal guardian to participate. Employees, officers, directors, and their immediate families (spouse, parents, siblings, and children) of {{practiceName}}, its affiliates, subsidiaries, advertising and promotion agencies, and other coordinating agencies involved in the promotion of this Giveaway (collectively, the “Giveaway Entities”) are not eligible to enter.`,
        giveawayPeriod: `GIVEAWAY PERIOD: The Giveaway begins on {{startDate}} and ends on {{endDate}} (the “Giveaway Period”).`,
        howToEnter: `HOW TO ENTER: To enter, visit the {{practiceName}} Giveaway entry page at {{{url}}} and follow the instructions provided to complete and submit the entry form. Only one entry per person is allowed. Entrants must provide their full name, email address, and telephone number. Incomplete entries or entries that do not comply with these Official Rules will be disqualified. All entries must be received by the end of the Giveaway Period.`,
        winnerSelection: `WINNER SELECTION: The winners of the Giveaway will be selected by random drawing from among all eligible entries received during the Giveaway Period. The drawing will be conducted within 7 days after the end of the Giveaway Period. The odds of winning depend on the number of eligible entries received.`,
        winnerNotification: `WINNER NOTIFICATION: The winners will be notified by email within 7 days after the drawing. {{practiceName}} is not responsible for any delays in notification due to technical issues or otherwise. If a potential winner cannot be contacted within 7 days after the first attempt to contact him/her, or if he/she fails to respond to the notification within 7 days, or if he/she fails to comply with these Official Rules, such potential winner will be disqualified and forfeit his/her prize. If a potential winner is disqualified for any reason, {{practiceName}} will award the applicable prize to an alternate winner by random drawing from among all remaining eligible entries.`,
        prize: `PRIZE: The prize for the Giveaway is {{prize}}. The prize is non-transferable and no substitution will be made except as provided herein at the sole discretion of {{practiceName}}. The prize is awarded “as is” with no warranty or guarantee, either express or implied by {{practiceName}}. {{practiceName}} reserves the right to substitute the prize with another prize of equal or greater value if the designated prize should become unavailable for any reason. The prize will be awarded within 7 days after the winner is selected.`,
        release: `RELEASE: By participating in the Giveaway, each entrant agrees to release and hold harmless the Giveaway Entities from and against any claim or cause of action arising out of participation in the Giveaway or receipt or use of the prize, including, but not limited to: (a) unauthorized human intervention in the Giveaway; (b) technical errors related to computers, servers, providers, or telephone or network lines; (c) printing errors; (d) lost, late, postage-due, misdirected, or undeliverable mail; (e) errors in the administration of the Giveaway or the processing of entries; or (f) injury or damage to persons or property which may be caused, directly or indirectly, in whole or in part, from entrant’s participation in the Giveaway or receipt of the prize. Entrant further agrees that in any cause of action, the Giveaway Entities’ liability will be limited to the cost of entering and participating in the Giveaway, and in no event shall the Giveaway Entities be liable for attorney’s fees. Entrant waives the right to claim any damages whatsoever, including, but not limited to, punitive, consequential, direct, or indirect damages.`,
      },
    },
  },
  dashboard: {
    title: 'Promotions',
    seeAll: 'See All',
  },
  contactInfoFields: {
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Mobile Phone',
    email: 'Email',
    childFirstName: 'Child First Name',
    childLastName: 'Child Last Name',
    isNotRealUser: 'Please leave this box unchecked',
  },
  contactInfoErrors: {
    required: '{{ fieldName }} is required.',
  },
  contactMe: {
    title: 'New Customer Inquiry',
    subtitle:
      'Interested in our products or services? Enter your details, and we will contact you with more information.',
    postInfoFields: {
      [InterestedPartyType.myself]: 'Interested in services for myself',
      [InterestedPartyType.myChild]: 'Interested in services for my child',
    },
    buttonText: 'Contact Me',
  },

  signUp: {
    title: 'Sign Up For This Promotion',
    subtitle: 'We will contact you to set up your next steps',
    postInfoFields: {
      isMember: {
        label: 'Are you a current Member? *',
        options: {
          yes: 'Yes, I am a member',
          no: 'No, I am not a member',
        },
        requiredError: 'Please select whether or not you are a current member.',
      },
      [InterestedPartyType.myself]: 'Sign me up',
      [InterestedPartyType.myChild]: 'Sign my child up',
    },
    buttonText: 'Sign Up',
  },

  form: {
    catastrophicError:
      'Something went wrong, please try submitting the form again.',
  },

  formConfirmation: {
    callUsNow: `Don't want to wait? Give us a call now.`,
  },

  // "micro-site"
  empty: {
    title: 'There are no promotions or events at this time.',
    subtitle:
      'Scheduled promotions and events by {{{ name }}} will show here. Check back later.',
    logoAlt: '{{ name }} logo',
  },
  main: {
    highlighted: {
      actionButton: 'Learn More',
    },
    type: {
      events: 'Events',
      offers: 'Offers',
      giveaways: 'Giveaways',
    },
    showMore: 'Show {{ quantity }} {{ title }}',
  },
};
